import styled from 'styled-components';

/**
 * Displays N lines of text. Any text that goes beyond that is truncated. The
 * truncated piece is replaced by ellipsis.
 * For more see https://css-tricks.com/line-clampin/#aa-the-standardized-way
 *
 * @param {number} [maxNumLines=2] - How many lines until text is cut off
 */
const LineLimitedText = styled.p<{ $maxNumLines?: number }>`
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: ${p => p.$maxNumLines || 2}; /* 2 as the default */
  -webkit-box-orient: vertical;
`;

export default LineLimitedText;
